import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import instance from "../../axios";
import Loader from "../../Layout/Loader";
import Button from "../../Components/common/Button";
import { errorHandler } from "../../Helpers";
import withTranslationWrapper from "../../HOC/withTranslation";

class PaymentCallback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: true,
      verified: false,
      error: false,
      message: "",
      chargeId: "",
      verifyResult: null,
    };
  }

  componentDidMount() {
    this.verifyPayment();
  }

  getChargeIdFromQuery = () => {
    const params = new URLSearchParams(window.location.search);
    return (
      params.get("chargeId") ||
      params.get("charge_id") ||
      params.get("tap_id") ||
      params.get("tapId") ||
      sessionStorage.getItem("tapChargeId") ||
      ""
    );
  };

  getBookingId = (verifyRes) => {
    const params = new URLSearchParams(window.location.search);
    return (
      verifyRes?.bookingId ||
      verifyRes?.booking_id ||
      verifyRes?.serviceId ||
      params.get("bookingId") ||
      params.get("serviceId") ||
      sessionStorage.getItem("tapBookingId") ||
      ""
    );
  };

  getPaymentId = (verifyRes) =>
    verifyRes?.paymentId || verifyRes?.payment_id || "";

  updateBookingPaidStatus = (bookingId) => {
    if (!bookingId) return Promise.resolve();
    return instance({
      method: "GET",
      url: `/api/services/updatepaymentstatus/${encodeURIComponent(
        bookingId,
      )}?paid=true`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }).catch((error) => {
      errorHandler(error, this.props.dispatch);
    });
  };

  updatePaymentRef = (paymentId, bookingId) => {
    if (!paymentId || !bookingId) return Promise.resolve();
    return instance({
      method: "PATCH",
      url: `/api/payments/updateref?paymentId=${encodeURIComponent(
        paymentId,
      )}&refNo=${encodeURIComponent(bookingId)}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }).catch((error) => {
      errorHandler(error, this.props.dispatch);
    });
  };

  isVerifySuccess = (res) => {
    if (res?.success === true || res?.success === "true") return true;
    if (res?.verified === true) return true;
    const status = String(
      res?.status ||
        res?.paymentStatus ||
        res?.charge?.status ||
        res?.data?.status ||
        "",
    ).toUpperCase();
    const successStatuses = [
      "CAPTURED",
      "SUCCESS",
      "PAID",
      "COMPLETED",
      "AUTHORIZED",
    ];
    if (successStatuses.includes(status)) return true;
    const failedStatuses = [
      "FAILED",
      "DECLINED",
      "CANCELLED",
      "CANCELED",
      "ABANDONED",
      "TIMEDOUT",
      "EXPIRED",
      "INITIATED",
    ];
    if (failedStatuses.includes(status)) return false;
    // Prefer explicit success flag; otherwise treat unknown non-failed as success only if success key present
    if (Object.prototype.hasOwnProperty.call(res || {}, "success")) {
      return Boolean(res.success);
    }
    return !failedStatuses.includes(status) && Boolean(status);
  };

  verifyPayment = () => {
    const chargeId = this.getChargeIdFromQuery();
    if (!chargeId) {
      this.setState({
        loader: false,
        verified: false,
        error: true,
        message:
          this.props.translate("chargeIdMissing") ||
          "Payment charge id is missing",
      });
      return;
    }

    this.setState({ loader: true, chargeId, error: false });

    instance({
      method: "GET",
      url: `/api/payments/tap/verify?chargeId=${encodeURIComponent(chargeId)}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        sessionStorage.removeItem("tapChargeId");
        const isSuccess = this.isVerifySuccess(res);
        const bookingId = this.getBookingId(res);
        const paymentId = this.getPaymentId(res);

        if (isSuccess) {
          if (bookingId && paymentId) {
            await this.updatePaymentRef(paymentId, bookingId);
          }
          if (bookingId) {
            await this.updateBookingPaidStatus(bookingId);
            sessionStorage.removeItem("tapBookingId");
          }
        }

        this.setState({
          loader: false,
          verified: isSuccess,
          error: !isSuccess,
          verifyResult: res,
          message: isSuccess
            ? this.props.translate("paymentVerified") ||
              "Payment verified successfully"
            : this.props.translate("paymentNotVerified") ||
              "Payment could not be verified",
        });
      })
      .catch((error) => {
        this.setState({
          loader: false,
          verified: false,
          error: true,
          message:
            this.props.translate("paymentNotVerified") ||
            "Payment could not be verified",
        });
        errorHandler(error, this.props.dispatch);
      });
  };

  goToPayments = () => {
    const params = new URLSearchParams(window.location.search);
    const returnTo =
      params.get("returnTo") ||
      sessionStorage.getItem("tapReturnTo") ||
      "payments";
    sessionStorage.removeItem("tapReturnTo");
    if (returnTo === "maintenance") {
      this.props.history.push("/maintenance");
      return;
    }
    this.props.history.push("/payments");
  };

  render() {
    const { translate, themecolors } = this.props;
    const { loader, verified, error, message, chargeId } = this.state;

    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: themecolors?.backgroundColor || "#f5f5f5",
          color: themecolors?.textColor || "#222",
          padding: 24,
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: 480,
            background: "#fff",
            borderRadius: 8,
            padding: 32,
            boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
            textAlign: "center",
          }}
        >
          <h2 style={{ marginTop: 0 }}>
            {translate("paymentStatus") || "Payment Status"}
          </h2>

          {loader ? (
            <Loader />
          ) : (
            <>
              <p
                style={{
                  fontSize: 16,
                  color: verified ? "#2e7d32" : error ? "#c62828" : "inherit",
                  marginBottom: 8,
                }}
              >
                {message}
              </p>
              {chargeId ? (
                <p style={{ fontSize: 13, opacity: 0.7, marginBottom: 24 }}>
                  {translate("chargeId") || "Charge Id"}: {chargeId}
                </p>
              ) : null}
              <Button size="small" onClick={this.goToPayments}>
                {translate("ok") || "OK"}
              </Button>
            </>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  themecolors: state.themeColors,
  logInUser: state.logInUsers,
});

export default connect(mapStateToProps)(
  withRouter(withTranslationWrapper(PaymentCallback)),
);
